import { render, staticRenderFns } from "./ArticleLocket.vue?vue&type=template&id=0d6bfd0c&"
import script from "./ArticleLocket.vue?vue&type=script&lang=js&"
export * from "./ArticleLocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports